export class AddKompetencerPatchModel {
    constructor(forloebId: string, laegeKompetenceIds: string[]) {
        this.forloebId = forloebId;
        this.laegeKompetenceIds = laegeKompetenceIds;
    }

    forloebId: string;
    laegeKompetenceIds: string[];
}
